import * as React from 'react';

import {Glyphicon} from 'react-bootstrap';

import {DisplayFeature, DisplayFeatureType, UserSession} from '../domain';
import {OnNewFeatureTypeComment} from '../../../actions/actions';
import {Comment} from '../../../../integration/representation/contract';

interface CommentIconProps {
    contractId: string;
    source: DisplayFeature| DisplayFeatureType;
    comments: Comment[];
    objectId: string | number;
    objectName: string;
    selectedFeatures: string[];
    setFeatureOrTypeIdForComments: (value: string | number) => void;
    user: UserSession;
    showCommentsModal: () => void;
    onDeleteComments: (commentIds: string[]) => void;
    onNewComment: OnNewFeatureTypeComment;
    enableCommentCopy?: boolean;
}

export default class CommentIcon extends React.Component<CommentIconProps, {}> {

    constructor(props: CommentIconProps) {
        super(props);
        this.openComments = this.openComments.bind(this);
    }

    openComments() {
        this.props.setFeatureOrTypeIdForComments(this.props.objectId);
        this.props.showCommentsModal();
    }

    render() {
        const comments: Comment[] = this.props.comments;
        const objectId: string | number = this.props.objectId;
        const commentResource = typeof objectId === 'number' ? 'FEATURE_TYPE_COMMENT' : 'FEATURE_COMMENT';
        const commentType = commentResource === 'FEATURE_TYPE_COMMENT' ? 'feature-type' : 'feature';
        let classes = comments && comments.length > 0 ? 'clickable populated ' + commentType : 'clickable';
        const hasError = (comments && comments.some(comment => comment.error));
        if (hasError) {
            classes = classes + ' error';
        }

        return (
            <span className="CommentIcon spaced" >
                <div className="relative" onClick={this.openComments}>
                    <Glyphicon glyph="comment" title="Vis kommentarer" className={classes}/>
                    <div className="glyph-text-overlay">
                        {comments.length > 0 ? comments.length : ''}
                    </div>
                </div>
            </span>
        );
    }
}
